// import React from 'react';

// function SummaryCost() {
//   const powerBiUrl = "https://app.powerbi.com/reportEmbed?reportId=307e4a99-46aa-4845-9947-af206924451c&autoAuth=true&ctid=b161c897-0ae2-42a0-be86-8f7e36f2049f";

//   return (
    
//       <iframe  title="Power BI Report"  src={powerBiUrl}  sandbox="allow-scripts allow-same-origin allow-forms allow-popups" allowFullScreen></iframe>
    
//   );
// }

// export default  SummaryCost;

import React,{ useEffect, useState } from 'react';
import { queuedApiFetch } from '../api';

function SummaryCost() {
    const [powerBiUrl, setPowerBiUrl] = useState('');
    const url_name='SummaryCost';

    useEffect(() => {
        const fetchData = async () => {
            try {
                const requestOptions = { method: 'GET' };
                const data = await queuedApiFetch(
                    `/project/get_powerbi_url?url_name=${url_name}`,
                    requestOptions
                );

                if (
                    data?.apistatus?.Status_Code === 200 &&
                    data?.apistatus?.Status_Description?.toLowerCase() === 'success'
                ) {
                    setPowerBiUrl(data.data); 
                } else {
                    console.error('Failed to load Power BI URL');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            } 
        };

        fetchData();
    }, []);


    return (

        <iframe title="Power BI Report" src={powerBiUrl} sandbox="allow-scripts allow-same-origin allow-forms allow-popups" referrerpolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

    );
}

export default SummaryCost;
